/**
 * Client IA de la console : valide les réponses partagées et utilise le client
 * de session existant. Les plafonds restent en cents (null pour le défaut) ;
 * aucune mise à jour anticipée, le serveur confirme chaque écriture motivée.
 */
import {
  reponseConsoleIaSchema,
  reponseConsoleGalerieIaSchema,
  type coupureIaSchema,
  type reglagesGalerieIaSchema,
} from '@artosera/shared';
import type { z } from 'zod';
import { requete, modeDemo } from './api.js';
import { demoIa, demoIaGalerie, ecrireDemoIa, ecrireDemoIaGalerie } from './demoIa.js';

export type ConsoleIa = z.infer<typeof reponseConsoleIaSchema>;

export type GalerieIa = z.infer<typeof reponseConsoleGalerieIaSchema>;

export type CoupureIa = z.infer<typeof coupureIaSchema>;

export type ReglagesIa = z.infer<typeof reglagesGalerieIaSchema>;

const chemin = (id: string) => `/v1/console/galleries/${encodeURIComponent(id)}/ia`;

export const iaConsoleApi = {
  globale: async () =>
    reponseConsoleIaSchema.parse(modeDemo() ? demoIa() : await requete('/v1/console/ia')),
  couper: async (corps: CoupureIa) =>
    reponseConsoleIaSchema.parse(
      modeDemo()
        ? ecrireDemoIa(corps)
        : await requete('/v1/console/ia/coupure', { methode: 'PUT', corps }),
    ),
  galerie: async (id: string) =>
    reponseConsoleGalerieIaSchema.parse(modeDemo() ? demoIaGalerie(id) : await requete(chemin(id))),
  regler: async (id: string, corps: ReglagesIa) =>
    reponseConsoleGalerieIaSchema.parse(
      modeDemo()
        ? ecrireDemoIaGalerie(id, corps)
        : await requete(chemin(id), { methode: 'PUT', corps }),
    ),
};
